const serviceReportService = require('../../services/serviceReport/serviceReportService')

const state = {
  serviceReport: {},
}

const mutations = {
  setServiceReport(state, serviceReport) {
    state.serviceReport = serviceReport
  },
}

const actions = {
  async fetchServiceReport({ commit }, appointmentId) {
    commit('setIsLoading', true)

    await serviceReportService
      .fetchServiceReport(appointmentId)
      .then(({ data }) => {
        commit('setServiceReport', data)
      })
      .catch(() => {
        commit('setServiceReport', null)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },

  async fetchServiceReportAsAdmin({ commit }, appointmentId) {
    commit('setIsLoading', true)

    await serviceReportService
      .fetchServiceReportAsAdmin(appointmentId)
      .then(({ data }) => {
        commit('setServiceReport', data)
      })
      .catch(() => {
        commit('setServiceReport', null)
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  },
}

const getters = {
  serviceReport: (state) => state.serviceReport,
}

export default {
  state,
  mutations,
  actions,
  getters,
}
